import {
  Box,
  Button,
  IconButton,
  Paper,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Header from "../../components/Header";
import { tokens } from "../../theme";
import { useEffect, useLayoutEffect, useMemo, useState } from "react";
import axios from "axios";
import { DATA_SAVE_URL } from "../utils/UrlHandle";
import NotificationToaste from "../global/NotificationToaste";
import JobRequestPaymentUtils from "./JobRequestPaymentUtils";
import MenuItemMui from "@mui/material/MenuItem";

import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { MenuItem } from "react-pro-sidebar";
import {
  Circle,
  Delete,
  Edit,
  Email,
  FileDownload,
  Google,
  Payment,
  Preview,
  WhatsApp,
} from "@mui/icons-material";
import ConfirmationDialog from "../global/ConfirmationDialog";
import JobInvoiceDialog from "../newJob/JobInvoiceDialog";
import { download, generateCsv, mkConfig } from "export-to-csv";
import LoadingBackDrop from "../global/LoadingBackDrop";
import { setDeletePayload } from "../../services/api";
import PDFViewerDialog from "../jasperReports/PDFViewerDialog";
import PDFSendWhatsAppDialog from "../jasperReports/PDFSendWhatsAppDialog";

const JobRequestPayment = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [loading, setLoading] = useState(false);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [year, setYear] = useState([
    { id: 1, label: "2025", value: "2025" },
    { id: 2, label: "2026", value: "2026" },
  ]);
  const [currentYear, setCurrentYear] = useState(2026);
  const [pendingsCreditJobs, setPendingCreditJobs] = useState([]);
  const [officers, setOfficers] = useState([]);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState();
  const [messageType, setMessageType] = useState();
  const [sendEmail, setSendEmail] = useState(false);
  const handleCloseToaste = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const [sendReportType, setSendReportType] = useState("");
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openInvoiceDialog, setOpenInvoiceDialog] = useState(false);
  const [selectedRequestId, setSelectedRequestId] = useState({});
  const [save, setSave] = useState(true);
  const loggedUser = JSON.parse(localStorage.getItem("user"));
  const [openWhatsAppPreviewDialog, setOpenWhatsAppPreviewDialog] =
    useState(false);
  const handleCloseWhatsAppPreview = () => {
    setOpenWhatsAppPreviewDialog(false);
  };

  const handleOpenWhatsAppPreview = () => {
    setOpenWhatsAppPreviewDialog(true);
  };

  const handleClickOpenDialog = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenConfirmDialog(false);
  };
  //Open invoice modal

  const handleOpenInvoice = () => {
    setOpenInvoiceDialog(true);
  };

  const handleCloseInvoice = () => {
    setOpenInvoiceDialog(false);
  };

  useLayoutEffect(() => {
    loadBasicData(currentYear);
  }, [save]);

  const loadBasicData = async (year) => {
    setLoading(true);
    const token = localStorage.getItem("token");
    await axios
      .get(DATA_SAVE_URL + `/api/v1/labReq/all/creditNewJobs?year=${year}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function (response) {
        // console.log(response.data);
        setPendingCreditJobs(response.data.creditRequests);
        setData(response.data.allRequests);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  const handledeletePayment = async () => {
    // console.log("object", data);
    handleCloseDialog(true);
    setLoading(true);

    await setDeletePayload
      .setPayloadData("/labPayment/delete/" + selectedRequestId.id, null)
      .then(function (response) {
        // console.log(response.data);
        setSave((pre) => (pre === true ? false : true));
        setData(response.data);
        setMessage("Payment deleted successfully..!");
        setLoading(false);
        setMessageType("success");
        setOpen(true);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  const handleSendEmail = async () => {
    // console.log("object", data);
    handleCloseDialog(true);
    setLoading(true);
    await axios
      .put(
        DATA_SAVE_URL + "/api/v1/labPayment/sendEmail/" + selectedRequestId.id
      )
      .then(function (response) {
        // console.log(response.data);
        setMessage("Email sent successfully..!");
        setLoading(false);
        setMessageType("success");
        setOpen(true);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  const [data, setData] = useState([]);
  //should be memoized or stable
  const columns = useMemo(
    () => [
      {
        accessorFn: (row) =>
          `${row.labRequest.year}/${String(
            row.labRequest.autoIdByYear
          ).padStart(4, "0")}`,
        //accessorKey: "institute.instituteName", //access nested data with dot notation
        header: "Job No",
        size: 80,
      },
      {
        accessorKey: "labRequest.institute.instituteName", //access nested data with dot notation
        header: "Institute / Contractor",
        size: 200,
      },
      {
        accessorKey: "labRequest.regDate",
        header: "Date",
        size: 80,
      },
      {
        accessorKey: "paymentDate",
        header: "Payment Date",
        size: 80,
      },
      {
        accessorKey: "paymentMethod",
        header: "P.Method",
        size: 100,
      },

      {
        accessorKey: "remark",
        header: "Remark",
        size: 100,
      },
      {
        accessorFn: (row) =>
          `${row.payment.toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })}`,
        header: "Amount",
        size: 100,
        muiTableBodyCellProps: {
          align: "right",
        },
      },
    ],
    []
  );
  // const csvConfig = mkConfig({
  //   fieldSeparator: ",",
  //   decimalSeparator: ".",
  //   useKeysAsHeaders: true,
  // });

  // const handleExportRows = (rows) => {
  //   const rowData = rows.map((row) => row.original);
  //   const csv = generateCsv(csvConfig)(rowData);
  //   download(csvConfig)(csv);
  // };

  // const handleExportData = () => {
  //   const csv = generateCsv(csvConfig)(data);
  //   download(csvConfig)(csv);
  // };

  const table = useMaterialReactTable({
    columns,
    data,
    enableRowActions: true,
    positionActionsColumn: "last",
    // renderTopToolbarCustomActions: ({ table }) => (
    //   <Box
    //     sx={{
    //       display: "flex",
    //       gap: "16px",
    //       padding: "8px",
    //       flexWrap: "wrap",
    //     }}
    //   >
    //     <Button
    //       //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
    //       onClick={handleExportData}
    //       startIcon={<FileDownload />}
    //     >
    //       Export All Data
    //     </Button>
    //     <Button
    //       disabled={table.getPrePaginationRowModel().rows.length === 0}
    //       //export all rows, including from the next page, (still respects filtering and sorting)
    //       onClick={() =>
    //         handleExportRows(table.getPrePaginationRowModel().rows)
    //       }
    //       startIcon={<FileDownload />}
    //     >
    //       Export All Rows
    //     </Button>
    //     <Button
    //       disabled={table.getRowModel().rows.length === 0}
    //       //export all rows as seen on the screen (respects pagination, sorting, filtering, etc.)
    //       onClick={() => handleExportRows(table.getRowModel().rows)}
    //       startIcon={<FileDownload />}
    //     >
    //       Export Page Rows
    //     </Button>
    //     <Button
    //       disabled={
    //         !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
    //       }
    //       //only export selected rows
    //       onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
    //       startIcon={<FileDownload />}
    //     >
    //       Export Selected Rows
    //     </Button>
    //   </Box>
    // ),
    initialState: {
      density: "compact",
      pagination: { pageSize: 25, pageIndex: 0 },
    },

    muiPaginationProps: {
      rowsPerPageOptions: [25, 50, 100, 150, 200],
      showFirstButton: true,
      showLastButton: true,
    },

    muiTableBodyRowProps: ({ row }) => ({
      //conditionally style expanded rows
      // sx: {
      //   padding: "10px",
      //   backgroundColor:
      //     row.original.paid === true ? colors.greenAccent[800] : "#FAD02C",
      // },
    }),

    renderRowActions: ({ closeMenu, row }) => [
      <Tooltip title="View Invoice">
        <IconButton
          onClick={() => {
            console.log(row.original);
            setSelectedRequestId(row.original.labRequest);
            handleOpenInvoice();
          }}
          aria-label="View Report"
          size="medium"
        >
          <Preview fontSize="inherit" color="warning" />
        </IconButton>
      </Tooltip>,
      <Tooltip title="Send Email">
        <IconButton
          onClick={() => {
            console.log(row);
            setSendReportType("EMAIL");
            setSelectedRequestId(row.original.labRequest);
            handleOpenWhatsAppPreview();
          }}
          aria-label="Send Email"
          size="medium"
        >
          <Google fontSize="inherit" color="error" />
        </IconButton>
      </Tooltip>,
      <Tooltip title="Send WhatsApp Link">
        <IconButton
          onClick={() => {
            setSendReportType("WHATSAPP");
            setSelectedRequestId(row.original.labRequest);
            handleOpenWhatsAppPreview();
          }}
          aria-label="Send WhatsApp Link"
          size="medium"
        >
          <WhatsApp fontSize="inherit" color="success" />
        </IconButton>
      </Tooltip>,
      <Tooltip title="Delete Payment">
        <IconButton
          onClick={() => {
            setSelectedRequestId(row.original);
            handleClickOpenDialog();
          }}
          aria-label="Send WhatsApp Link"
          size="medium"
        >
          <Delete fontSize="inherit" color="error" />
        </IconButton>
      </Tooltip>,
    ],
  });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {loading ? <LoadingBackDrop openBackDrop={loading} /> : ""}
      <Paper
        sx={{ padding: "15px", borderRadius: "8px", width: "95%" }}
        elevation={3}
      >
        <Box display="flex" justifyContent="space-between">
          <Header
            title="Job Request Payments"
            subtitle="Pending new requests"
          />

          <Box
            sx={{
              textAlign: "center",
              alignContent: "center",
            }}
          >
            <Typography
              color={colors.redAccent[500]}
              alignContent="center"
              variant="h3"
            ></Typography>
          </Box>
          <TextField
            select
            label="Select year"
            size="small"
            value={currentYear}
            onChange={(e) => {
              setCurrentYear(e.target.value);
              loadBasicData(e.target.value);
            }}
            sx={{
              marginBottom: "5px",
              marginTop: "8px",
              gridColumn: "span 2",

              width: "150px",
            }}
          >
            {year?.map((option) => (
              <MenuItemMui key={option.id} value={option.value}>
                {option.value}
              </MenuItemMui>
            ))}
          </TextField>
        </Box>
        <Box display="flex" flexDirection="row" justifyContent="center"></Box>
        {pendingsCreditJobs?.map((data, index) => (
          <JobRequestPaymentUtils
            key={index}
            colors={colors}
            isNonMobile={isNonMobile}
            id={data.id}
            year={data.year}
            regDate={data.regDate}
            project={data.project}
            institute={data.institute.instituteName}
            contactNo={data.contactNo}
            contactPerson={data.contactPerson}
            email={data.email}
            grandTotal={data.grandTotal}
            paid={data.paid}
            officers={officers}
            setOpen={setOpen}
            setMessage={setMessage}
            setMessageType={setMessageType}
            data={data}
            labTests={data.labRequestTests}
            index={index}
            setLoading={setLoading}
            loading={loading}
            labRequestInvoice={data.labRequestInvoice}
            balance={data.balance}
            setSave={setSave}
          />
        ))}
      </Paper>
      <Paper
        sx={{
          padding: "15px",
          borderRadius: "8px",
          width: "95%",
          marginTop: "15px",
        }}
        elevation={3}
      >
        <Header title="All Payments" subtitle="Update / Delete " />

        <MaterialReactTable table={table} />
      </Paper>
      <NotificationToaste
        handleCloseToaste={handleCloseToaste}
        open={open}
        message={message}
        messageType={messageType}
      />
      <ConfirmationDialog
        confirmationMessage={
          sendEmail
            ? "Are you sure you’d like to send it now? If you’d like to review or make any changes, please update before send!"
            : "Are you sure that you need delete selected paymemnt?"
        }
        openConfirmDialog={openConfirmDialog}
        handleCloseDialog={handleCloseDialog}
        messageTitle={sendEmail ? "Send Email" : "Delete Payment"}
        dialogFunction={sendEmail ? handleSendEmail : handledeletePayment}
      />

      {/* <JobInvoiceDialog
        isNonMobile={isNonMobile}
        colors={colors}
        handleOpenInvoice={handleOpenInvoice}
        handleCloseInvoice={handleCloseInvoice}
        open={openInvoiceDialog}
        data={selectedRequestId.labRequest}
        type={"INVOICE"}
      /> */}

      <PDFViewerDialog
        reportNo={`INV_${selectedRequestId?.id}_${
          selectedRequestId?.year
        }_${String(selectedRequestId?.id).padStart(4, "0")}`}
        labRequestId={selectedRequestId?.barcode}
        open={openInvoiceDialog}
        handleCloseReportPreview={handleCloseInvoice}
        letterHead={""}
        jobId={selectedRequestId?.id}
        reportType={"INVOICE"}
      />

      <PDFSendWhatsAppDialog
        reportNo={`INV_${selectedRequestId?.year}_${String(
          selectedRequestId?.id
        ).padStart(4, "0")}`}
        jobNo={`JOB/${selectedRequestId?.year}/${String(
          selectedRequestId?.id
        ).padStart(4, "0")}`}
        labRequestId={selectedRequestId?.barcode}
        open={openWhatsAppPreviewDialog}
        handleCloseReportPreview={handleCloseWhatsAppPreview}
        loggedUserData={`${loggedUser.firstName} ${loggedUser.lastName}`}
        contactNo={selectedRequestId?.institute?.contactNo}
        emailAddress={selectedRequestId?.institute?.email}
        sendReportType={sendReportType}
        jobId={selectedRequestId?.id}
      />
    </Box>
  );
};

export default JobRequestPayment;
